<template>
  <v-col class="troubleshooting-content">
    <v-row>
      <v-col>
        <docs-hero-banner
          eyebrow="Troubleshooting"
          title="Resolve Common Issues Faster"
          description="Use these checks to confirm whether the problem is context, permissions, filters, or a genuine product issue before escalating."
          :meta-items="heroMetaItems"
        />
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="12">
        <docs-callout
          title="First check"
          color="warning"
          :icon="['fas', 'triangle-exclamation']"
        >
          Most data and access issues trace back to selected context,
          role-based permissions, or active filters. Verify those before you
          assume a backend or product failure.
        </docs-callout>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <docs-section-card
          title="Why do I not see expected data?"
          description="Confirm selected context, role permissions, and filter state before assuming data is missing."
          :icon="['fas', 'database']"
        >
          <ul class="body-2 mb-0 pl-4">
            <li class="mb-1">
              Reconfirm your selected network, team, or project context.
            </li>
            <li class="mb-1">
              Clear active filters and search text.
            </li>
            <li>Check whether the page is role-gated for internal-only actions.</li>
          </ul>
        </docs-section-card>
      </v-col>
      <v-col cols="12">
        <docs-section-card
          title="Search returns no results"
          description="Check spelling, access scope, and whether your account has access to the resource type you searched for."
          :icon="['fas', 'magnifying-glass']"
        >
          <ul class="body-2 mb-0 pl-4">
            <li class="mb-1">
              Try shorter search terms or remove punctuation.
            </li>
            <li class="mb-1">
              Verify you are searching within the correct area of the app.
            </li>
            <li>Ask an internal admin to confirm your access scope if results stay empty.</li>
          </ul>
        </docs-section-card>
      </v-col>
      <v-col cols="12">
        <docs-section-card
          title="Projects actions are disabled"
          description="Some actions are role-gated. If needed, ask an internal admin to grant or verify your permissions."
          :icon="['fas', 'lock']"
        >
          <ul class="body-2 mb-0 pl-4">
            <li class="mb-1">
              Confirm whether the current action is internal-only.
            </li>
            <li class="mb-1">
              Check whether the record is archived or otherwise protected.
            </li>
            <li>Escalate with the route, record, and your current role if access still looks wrong.</li>
          </ul>
        </docs-section-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: 'TroubleshootingContent',
  components: {
    DocsCallout: () => import('@/docs/components/DocsCallout.vue'),
    DocsHeroBanner: () => import('@/docs/components/DocsHeroBanner.vue'),
    DocsSectionCard: () => import('@/docs/components/DocsSectionCard.vue'),
  },
  computed: {
    heroMetaItems() {
      return [
        { label: 'Audience: All signed-in users', icon: ['fas', 'users'] },
        { label: 'Use when something looks wrong', icon: ['fas', 'life-ring'] },
        { label: 'Escalate with route + context details', icon: ['fas', 'clipboard-list'] },
      ]
    },
  },
}
</script>
